import axios from './../../config/axios';

export function searchUsers(payload) {
    return axios().get(`/auth/users`, { params: payload } );
}
function list(payload) {
    return axios().get(`/auth/users` , { params: payload })
    
}
function index(payload) {
    return axios().get(`auth/users-list` , { params: payload })
}
function get(id) {
    return axios().get(`/auth/users/${id}`)
}
function roles(id) {
    return axios().get(`/auth/users/${id}/roles`)
}
function create(data) {
    return axios().post(`/auth/users`, data )
}
function update(data) {
    return axios().put(`/auth/users/${data.id}`, data)
}

function remove(id) {
    return axios().delete(`/auth/users/${id}`)
}
function updateRole(data) {
    return axios().put(`/auth/users/${data.id}/update-roles`, data)
}
export default {
    list,
    get,
    roles,
    create,
    update,
    remove,
    updateRole,
    index
}